<div class="nt-container">
  <div class="nt-full-width-loading-shade" *ngIf="isloading">
    <mat-spinner color="primary" *ngIf="isloading"></mat-spinner>
  </div>
</div>
<div class="container-fluid grid-example" style="height: 100%">
  <h2>{{ "routes.dashboard.TITLE" | translate }}!</h2>
  <div class="row" style="margin-top: 40px">
    <div class="col-xl-3 col-md-6">
      <!-- START card-->
      <a class="link-unstyled text-primary" [routerLink]="['/customer-manager']">
        <div class="card flex-row align-items-center align-items-stretch border-0">
          <div
            class="col-4 d-flex align-items-center bg-gray-light justify-content-center rounded-left"
          >
            <em class="icon-cloud-upload fa-3x"></em>
          </div>
          <div class="col-8 py-3 rounded-right">
            <div class="numbers-font-size mt-0">{{ count.customer }}</div>
            <div class="text-uppercase">
              {{ "routes.dashboard.tiles_admin.CUSTOMER" | translate }}
            </div>
          </div>
        </div>
      </a>
    </div>

    <div class="col-xl-3 col-lg-6 col-md-12">
      <!-- START card-->
      <div class="card flex-row align-items-center align-items-stretch border-0">
        <div
          class="col-4 d-flex align-items-center bg-gray-light justify-content-center rounded-left"
        >
          <em class="icon-calendar fa-3x"></em>
        </div>
        <div class="col-8 py-3 rounded-right">
          <div class="numbers-font-size mt-0">{{ count.resources }}</div>
          <div class="text-uppercase">
            {{ "routes.dashboard.tiles_admin.RESOURCES" | translate }}
          </div>
        </div>
      </div>
    </div>

    <!-- -->
    <div class="col-xl-3 col-lg-6 col-md-12">
      <!-- START card-->
      <div class="card flex-row align-items-center align-items-stretch border-0">
        <div
          class="col-4 d-flex align-items-center bg-gray-light justify-content-center rounded-left"
        >
          <em class="icon-bubbles fa-3x"></em>
        </div>
        <div class="col-8 py-3 rounded-right">
          <div class="numbers-font-size mt-0">{{ count.invoices }}</div>
          <div class="text-uppercase">
            {{ "routes.dashboard.tiles_admin.INVOICES" | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-12">
      <!-- START date widget-->
      <div class="card flex-row align-items-center align-items-stretch border-0">
        <div
          class="col-4 d-flex align-items-center bg-gray justify-content-center rounded-left"
        >
          <div class="text-center">
            <div class="text-sm" now format="MMMM"></div>
            <br />
            <div class="numbers-font-size mt-0" now format="D"></div>
          </div>
        </div>
        <div class="col-8 py-3 rounded-right">
          <div class="text-uppercase" now format="dddd"></div>
          <br />
          <div class="numbers-font-size mt-0" now format="HH:mm"></div>
        </div>
      </div>
      <!-- END date widget-->
    </div>
  </div>

  <div class="row">
    <div class="col-xl-3 col-lg-6 col-md-12">
      <!-- START card-->
      <!-- Made the license ready for the filter,
             but for now there is no such columns in provider admin -->
      <a class="link-unstyled text-primary">
        <div
          class="card flex-row align-items-center align-items-stretch border-0"
          [routerLink]="['/license-manager']"
          style="cursor: pointer"
        >
          <div
            class="col-4 d-flex align-items-center bg-gray-light justify-content-center rounded-left"
          >
            <em class="icon-doc fa-3x"></em>
          </div>
          <div class="col-8 py-3 rounded-right">
            <div class="numbers-font-size mt-0 devices-status-container">
              <div
                class="green"
                tooltip="{{ 'tooltips.license.dashboard.VALID' | translate }}"
                [routerLink]="['/license-manager']"
                [queryParams]="{ status: 'valid' }"
                style="cursor: pointer"
              >
                <span></span>
                {{ count.validLicemses }}
              </div>
              <div
                class="yellow"
                tooltip="{{ 'tooltips.license.dashboard.EXPIRESSOON' | translate }}"
                [routerLink]="['/license-manager']"
                [queryParams]="{ status: 'expires in 10 days' }"
                style="cursor: pointer"
              >
                <span></span>
                {{ count.expiredInTenDaysLicenses }}
              </div>
              <div
                class="red"
                tooltip="{{ 'tooltips.license.dashboard.EXPIRED' | translate }}"
                [routerLink]="['/license-manager']"
                [queryParams]="{ status: 'expired' }"
                style="cursor: pointer"
              >
                <span></span>
                {{ count.expiredLicenses }}
              </div>
            </div>
            <div class="text-uppercase">
              {{ "routes.dashboard.tiles_admin.LICENSES" | translate }}
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-12">
      <!-- START card-->
      <a class="link-unstyled text-primary">
        <div
          class="card flex-row align-items-center align-items-stretch border-0"
          style="cursor: pointer"
          [routerLink]="['/device-manager']"
        >
          <div
            class="col-4 d-flex align-items-center bg-gray-light justify-content-center rounded-left"
          >
            <em class="icon-screen-tablet fa-3x"></em>
          </div>
          <div class="col-8 py-3 rounded-right">
            <div class="numbers-font-size mt-0 devices-status-container">
              <div
                class="online-devices"
                style="cursor: pointer"
                [routerLink]="['/device-manager']"
                [queryParams]="{ status: 'online' }"
              >
                <span></span>
                {{ count.onlineDevices }}
              </div>
              <div
                class="offline-devices"
                style="cursor: pointer"
                [routerLink]="['/device-manager']"
                [queryParams]="{ status: 'offline' }"
              >
                <span></span>
                {{ count.offlineDevices }}
              </div>
              <!-- <small>GB</small> -->
            </div>
            <div class="text-uppercase">
              {{ "routes.dashboard.tiles.DEVICES" | translate }}
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>

  <div class="row">
    <div class="col"></div>
  </div>
</div>
